import { TrialResult } from 'interface/trial'
import { useState, useCallback } from 'react'

export const useTrialPreviewDialog = () => {
	const [trialList, setTrialList] = useState<TrialResult[]>([])
	const [trialId, setTrialId] = useState<number | null>(null)

	const openTrial = useCallback(
		(trialId: number | null) => {
			setTrialId(trialId)
		},
		[setTrialId]
	)
	const close = useCallback(
		() => openTrial(null),
		[openTrial]
	)
	return {
		trialList,
		trialId,
		setTrialList,
		openTrial,
		close
	}
}